import type { StyleRule } from '@archipro-design/aria';

export const ToolTipText: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        textAlign: 'center',
        maxWidth: 'unset',
    },
});
